import { Box, Button, Center, H1, HStack, Icon, Paragraph, ScrollView, View } from "components/ui";
import { ChevronLeft, X } from "lucide-react-native";
import React from "react";
import Modal from "react-native-modal";

type Props = {
	isOpen: boolean;
	toggleModal: () => void;
	children: React.ReactNode;
	headerIcon?: "close" | "back";
	headerTitle?: string;
	customHeader?: React.ReactNode;
	buttonTitle?: string;
	buttonAction?: (...args: any[]) => void;
};

const SlidePage = ({ isOpen, toggleModal, headerIcon = "back", headerTitle, buttonTitle, buttonAction, customHeader, children }: Props) => {
	return (
		<Modal animationIn={"slideInRight"} animationOut={"slideOutRight"} scrollOffset={1} style={{ margin: 0, position: "relative", backgroundColor: "#fff", height: "100%" }} propagateSwipe={true} isVisible={isOpen}>
			<View>
				{!customHeader ? (
					<HStack borderBottomWidth={1} paddingVertical={16} borderColor="$neutral100" w={"$full"} alignItems="center" justifyContent="space-between" paddingHorizontal={16}>
						<Button flex={1} justifyContent="flex-start" onPress={toggleModal} padding={0}>
							{headerIcon === "back" && <Icon size="lg" color="$basicblack" as={ChevronLeft} />}
							{headerIcon === "close" && <Icon color="$basicblack" as={X} />}
						</Button>

						<Box flexGrow={1}>
							<Center>
								<H1>{headerTitle ?? "No title"}</H1>
							</Center>
						</Box>
						<Box flex={1}></Box>
					</HStack>
				) : (
					customHeader
				)}
			</View>
			<ScrollView bg="$neutral25">
				<Box>{children}</Box>
			</ScrollView>
			{buttonTitle && (
				<Box w="$full" paddingHorizontal={16} paddingVertical={8}>
					<Button
						onPress={() => {
							if (!buttonAction) return console.log("No action provided for button");
							buttonAction();
						}}
						bg="$primary"
						paddingHorizontal={24}
						paddingVertical={16}
					>
						<Paragraph sx={{ color: "$basicwhite" }}>{buttonTitle}</Paragraph>
					</Button>
				</Box>
			)}
		</Modal>
	);
};

export default SlidePage;
